module.exports = __webpack_public_path__ + "media/images/landing/2-23a2c10ac11d9b1a45b069307aa02c0c.png";